import { useEffect } from 'react';
import { FormField } from 'ui/formField';
import { useFormContext } from 'react-hook-form';
import { RadioListField } from 'lib/iterable-hook-form';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  StyledRadioPercentSign,
  StyledExperimentGroupSizeGrid,
  StyledSmallerInputText,
  StyledAttributionCheckboxGridSection,
  StyledAttributionSizeGridSection,
  StyledFields,
  StyledErrorMessage,
  StyledTestStrategySectionText,
  StyledRadioListWrapper,
  StyledSecondaryOptionLabel,
} from 'modules/experiments/components/pages/edit/sections/settings/styled';
import { UpdateExperimentSettingsFormFieldNames } from 'modules/experiments/constants/updateExperimentSettings';
import {
  DEFAULT_TEST_SIZE_PERCENTAGE,
  MIN_TEST_SIZE_PERCENTAGE,
  MAX_TEST_SIZE_PERCENTAGE,
} from 'modules/experiments/takeover/constants';
import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { TestStrategy } from 'modules/experiments/types';

import { getRadioFieldOptions } from '../helpers';

export const AudienceFormBlastSubsetSetting = () => {
  const {
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();

  const { t } = useExperimentsTranslations();
  const {
    campaignSchedulerMsgParams: { scheduleType },
  } = useTakeoverExperimentContext();

  const { HOLDOUT_GROUP_SIZE, TEST_STRATEGY, HOLDOUT_TEST_SIZE_PERCENTAGE } =
    UpdateExperimentSettingsFormFieldNames;

  const blastSubsetTestStrategy = getValues(TEST_STRATEGY);
  const holdOutGroupSize = getValues(HOLDOUT_GROUP_SIZE);
  const showAttributionSize = blastSubsetTestStrategy === TestStrategy.SUBSET_USERS;

  useEffect(() => {
    trigger();
  }, [holdOutGroupSize, blastSubsetTestStrategy]);

  return (
    <StyledExperimentGroupSizeGrid
      data-test="blast-test-with-subset-setting"
      showAttributionSize={showAttributionSize}
    >
      <StyledTestStrategySectionText>
        {t('settings.settingsLabels.testStrategy')}
      </StyledTestStrategySectionText>

      <StyledAttributionCheckboxGridSection>
        <StyledRadioListWrapper data-test="send-to-remainder">
          <RadioListField
            name={TEST_STRATEGY}
            options={getRadioFieldOptions(t, scheduleType)}
            isRegularWeight={true}
          />
        </StyledRadioListWrapper>
      </StyledAttributionCheckboxGridSection>

      {showAttributionSize && (
        <StyledAttributionSizeGridSection>
          <StyledFields>
            <StyledSecondaryOptionLabel data-test="exp-group-size-label">
              {t('settings.testSizePercentage.label')}
            </StyledSecondaryOptionLabel>
            <FormField isHorizontalLayout inputId="exp-group-size">
              <StyledSmallerInputText
                name={HOLDOUT_TEST_SIZE_PERCENTAGE}
                valueAsNumber={true}
                type="number"
                data-test={'exp-group-size-input'}
                id="exp-group-size-input"
                Suffix={<StyledRadioPercentSign>%</StyledRadioPercentSign>}
                maxValue={MAX_TEST_SIZE_PERCENTAGE}
                minValue={MIN_TEST_SIZE_PERCENTAGE}
                placeholder={`${DEFAULT_TEST_SIZE_PERCENTAGE}`}
              />
            </FormField>
          </StyledFields>
          {!!errors[HOLDOUT_TEST_SIZE_PERCENTAGE] && (
            <StyledErrorMessage>
              {/* @ts-expect-error */}
              {errors[HOLDOUT_TEST_SIZE_PERCENTAGE]?.message}
            </StyledErrorMessage>
          )}
        </StyledAttributionSizeGridSection>
      )}
    </StyledExperimentGroupSizeGrid>
  );
};
